import { config } from "../../../utils/tenantConfig";

export const Logo = () => {
	return (
		<img
			src={config.logos.svg}
			alt="logo"
			className="img-fluid logo p-1 text-center"
		/>
	);
};
